<ckeditor #ckEditor
          id="{{idPrefix}}{{idSuffix}}"
          editorUrl="{{editorUrl}}"
          [(ngModel)]="bananaBox"
          [config]="config"
          (blur)="onChange()"
          [readOnly]="disabled">
</ckeditor>
